exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh4[data-v-2014fb94] {\n  margin: 0;\n}\n.info-section[data-v-2014fb94] {\n  margin: 60px 0;\n}\n.info-item[data-v-2014fb94] {\n  display: flex;\n  margin: 10px 0;\n}\n.item-field[data-v-2014fb94] {\n  flex-basis: 26%;\n}\n.item-field[data-v-2014fb94]::after {\n  content: \":\";\n}\n", ""]);

// exports
